import { ButtonMain } from '@quero-delivery/quero-components-web';
import React from 'react';
import { Modal } from '@querodelivery/uni-react';
import styles from './confirmation-modal.module.scss';
import { MODAL_WIDTH } from '@/_constants/styles';

export interface ConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  questionText: string | React.ReactNode;
  handleConfirm: () => void;
  isLoading: boolean;
}

function ConfirmationModal(props: ConfirmationModalProps) {
  const { open, onClose, handleConfirm, title, questionText, isLoading } =
    props;

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      width={MODAL_WIDTH.sm}
      header={title}
    >
      <div className={styles.container}>
        <h5>Atenção!</h5>
        <span>{questionText}</span>

        <div className={styles.containerButton}>
          <ButtonMain width="40%" secondary onClick={onClose}>
            Cancelar
          </ButtonMain>

          <ButtonMain
            onClick={handleConfirm}
            width="40%"
            loading={isLoading}
            className={styles.buttonStyle}
            disabled={isLoading}
          >
            Continuar
          </ButtonMain>
        </div>
      </div>
    </Modal>
  );
}

export { ConfirmationModal };
